import { Star, Image as ImageIcon, Tag } from 'lucide-react';
import CreditPackBuyButton from './CreditPackBuyButton';
import {
  creditPacks,
  creditPackBenefits,
  creditsBottomHighlights,
} from '../data/creditPricing';

/**
 * @param {{
 *   id?: string;
 *   bleed?: boolean;
 *   heading?: string;
 *   subtitle?: string;
 *   innerClassName?: string;
 * }} props
 */
function PricingSection({
  id,
  bleed = false,
  heading = 'Simple Credits Pricing',
  subtitle = 'Choose the pack that fits your design needs.',
  innerClassName = 'container section',
}) {
  return (
    <section
      id={id}
      className={`pricing-section${bleed ? ' pricing-section--bleed' : ''}`}
    >
      <div className={`pricing-section__inner ${innerClassName}`.trim()}>
        <header className="pricing-section__header">
          <span className="pricing-section__tag-icon" aria-hidden="true">
            <Tag size={22} strokeWidth={2} />
          </span>
          <h2 className="pricing-section__title">{heading}</h2>
          <p className="pricing-section__lead">{subtitle}</p>
        </header>

        <div className="credits-grid">
          {creditPacks.map((pack) => {
            const pricePerImage = (
              pack.perImageRate != null ? pack.perImageRate : pack.price / pack.images
            ).toFixed(2);
            return (
              <article
                key={pack.name}
                className={`credits-pack-card credits-pack-card--${pack.packKey}${
                  pack.recommended ? ' highlighted' : ''
                }`}
              >
                {pack.recommended && (
                  <div className="credits-popular-label">
                    <Star size={13} strokeWidth={2.5} />
                    MOST POPULAR
                  </div>
                )}

                <p className="credits-pack-name">{pack.name}</p>
                <p className="credits-price">${pack.price}</p>
                <p className="credits-count">
                  <span className="credits-count-inner">
                    {pack.images} credits
                  </span>
                </p>
                <p className="credits-rate">${pricePerImage} per image</p>

                <hr className="credits-divider" />

                <ul className="credits-benefits">
                  <li key="images-count">
                    <ImageIcon
                      size={15}
                      strokeWidth={2.2}
                      className="credits-benefit-icon"
                    />
                    {pack.images} Designs
                  </li>
                  {creditPackBenefits.map(({ icon: Icon, label }) => (
                    <li key={label}>
                      <Icon
                        size={15}
                        strokeWidth={2.2}
                        className="credits-benefit-icon"
                      />
                      {label}
                    </li>
                  ))}
                </ul>

                <CreditPackBuyButton packKey={pack.packKey} />
              </article>
            );
          })}
        </div>

        <div className="credits-trust-row credits-trust-row--grid">
          {creditsBottomHighlights.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className="credits-trust-item">
              <span
                className={`credits-trust-icon credits-trust-icon--tone-${(i % 3) + 1}`}
              >
                <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
              </span>
              <div className="credits-trust-item-text">
                <p className="credits-trust-title">{title}</p>
                <p className="credits-trust-desc">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingSection;
